var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 6C10.5 7.38071 9.38073 8.5 8.00002 8.5C6.6193 8.5 5.50002 7.38071 5.50002 6C5.50002 4.61929 6.6193 3.5 8.00002 3.5C9.38073 3.5 10.5 4.61929 10.5 6ZM9.25002 6C9.25002 6.69036 8.69037 7.25 8.00002 7.25C7.30966 7.25 6.75002 6.69036 6.75002 6C6.75002 5.30964 7.30966 4.75 8.00002 4.75C8.69037 4.75 9.25002 5.30964 9.25002 6Z",
    fill: "#1A3D82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 0.375C11.4947 0.375 14.4312 2.7652 15.2637 6C14.4312 9.2348 11.4947 11.625 8.00001 11.625C4.50532 11.625 1.56888 9.2348 0.736298 6C1.56888 2.7652 4.50532 0.375 8.00001 0.375ZM8.00001 10.375C5.20279 10.375 2.83209 8.53633 2.03578 6C2.83209 3.46366 5.20279 1.625 8.00001 1.625C10.7972 1.625 13.1679 3.46366 13.9642 6C13.1679 8.53633 10.7972 10.375 8.00001 10.375Z",
    fill: "#1A3D82"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewIcon);
export default __webpack_public_path__ + "static/media/viewIcon.b2390da24dd00d76597139e6cb3ccb5c.svg";
export { ForwardRef as ReactComponent };